import Logo from './media/Logo.svg';
import './App.css';
import Screen1 from './media/1Screen.svg';
import Screen2 from './media/Screen2.svg';
import Puzzle from './media/Puzzle.svg';
import Screen3 from './media/Screen3.svg';
import Screen4 from './media/Screen4.svg';
import Screen5 from './media/Screen5.svg';
import Screen6 from './media/Screen6.svg';
import Uni from './media/Univercity.svg';
import { useState } from 'react';

// Импортируем изображения для слайдера
import Avatar1 from './media/11319.jpg';
import Avatar2 from './media/9445.jpg';
import Avatar3 from './media/2150312119.jpg';
import Ques from './media/ques.png'
import Polina from './media/6897f6497bd0495bbc0cc0be4311420e.png'
import YarPhoto from './media/yaroslav.jpg';
import JuliaPhoto from './media/julia.jpg';
import DenisPhoto from './media/denis.jpg';
import Emblem1 from './media/emblem1.png';
import Emblem2 from './media/emblem2.png';
import PhoneIcon from './media/phone-icon.png';
import iconTeleg from './media/incontelg.png'
import CloseIcon from './media/close-icon.svg'; // Нужно добавить иконку закрытия
import DiplomaImage from './media/diplom.png';

// Функция для плавной прокрутки
const scrollToElement = (id) => {
  const element = document.getElementById(id);
  if (element) {
    const yOffset = -90; // Смещение для учета высоты фиксированного меню
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    
    window.scrollTo({top: y, behavior: 'smooth'});
  }
};

// Функция для прокрутки в начало страницы
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

// Компонент модального окна
function ContactPopup({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    question: '',
    agreement: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Здесь будет логика отправки формы
    console.log('Popup form submitted:', formData);
    onClose(); // Закрываем попап после отправки
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-form">
        <button className="popup-close" onClick={onClose}>
          <img src={CloseIcon} alt="Закрыть" />
        </button>
        
        <div className="popup-header">
          <h3>Оставьте свои контакты</h3>
          <p>Мы перезвоним вам в ближайшее время</p>
        </div>
        
        <form className="popup-content" onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Ваше имя</label>
            <div className="input-frame">
              <input
                type="text"
                name="name"
                placeholder="Например, Евгений"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
          
          <div className="input-group">
            <label>Название компании</label>
            <div className="input-frame">
              <input
                type="text"
                name="company"
                placeholder="Например, Динамика"
                value={formData.company}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
          
          <div className="input-group">
            <label>Ваш E-mail</label>
            <div className="input-frame">
              <input
                type="email"
                name="email"
                placeholder="evgeniy@gmail.com"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
          
          <div className="input-group">
            <label>Ваш вопрос</label>
            <div className="input-frame textarea-frame">
              <textarea
                name="question"
                placeholder="Подскажите, пожалуйста..."
                value={formData.question}
                onChange={handleInputChange}
                rows="4"
                required
              />
            </div>
          </div>
          
          <div className="agreement">
            <div className="checkbox-container">
              <input
                type="checkbox"
                name="agreement"
                checked={formData.agreement}
                onChange={handleInputChange}
                className="custom-checkbox"
                required
              />
              <span className="checkmark"></span>
            </div>
            <span className="agreement-text">
              Я даю согласие на обработку моих персональных данных, указанных в этой веб-форме, на условиях, изложенных в Политике в отношении обработки персональных данных в Интернете, с которой я ознакомился.
            </span>
          </div>
          
          <button type="submit" className="submit-button">
            Отправить
          </button>
        </form>
      </div>
    </div>
  );
}

// Компонент слайдера отзывов
function ReviewsSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Данные для отзывов
  const reviews = [
    {
      avatar: Avatar1,
      name: "Прохор Северянский",
      position: "Промпитерстрой Начальник рекламного отдела",
      text: "Платформа Динамика помогла мне понять, как взаимодействовать с сотрудниками моего отдела и наладить взаимоотношения в коллективе. Также я понял, кого можно повысить, а с кем — попрощаться. Платформа удобная, что где находится разобрался сразу."
    },
    {
      avatar: Avatar2,
      name: "Анна Иванова",
      position: "Компания XYZ Менеджер по развитию",
      text: "Отличная платформа! Очень помогла в организации работы нашего отдела. Интуитивно понятный интерфейс и мощный функционал. Рекомендую всем коллегам."
    },
    {
      avatar: Avatar3,
      name: "Дмитрий Петров",
      position: "ТехноИнновации Директор по IT",
      text: "Внедрили платформу в нашу компанию полгода назад. Результаты превзошли ожидания. Увеличилась продуктивность сотрудников, улучшилась коммуникация между отделами."
    }
  ];

  const nextSlide = () => {
    if (currentSlide < 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const prevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  return (
    <div className="reviews-section">
      <div className="reviews-header">
        <h2>Что говорят о нас клиенты</h2>
        <div className="arrows">
          <button 
            className={`arrow-button prev ${currentSlide === 0 ? 'disabled' : ''}`} 
            onClick={prevSlide}
            disabled={currentSlide === 0}
          >
            <div className="arrow-icon">
              <div className="arrow-circle"></div>
              <div className="arrow-line"></div>
            </div>
          </button>
          <button 
            className={`arrow-button next ${currentSlide === 1 ? 'disabled' : ''}`} 
            onClick={nextSlide}
            disabled={currentSlide === 1}
          >
            <div className="arrow-icon">
              <div className="arrow-circle"></div>
              <div className="arrow-line"></div>
            </div>
          </button>
        </div>
      </div>
      
      <div className="reviews-slider-container">
        <div 
          className="reviews-track" 
          style={{ 
            transform: `translateX(calc(-${currentSlide} * (300px + 30px) - ${currentSlide === 1 ? '24px' : '0px'}))`,
            transition: 'transform 0.5s ease'
          }}
        >
          {reviews.map((review, index) => (
            <div className="review-card" key={index}>
              <div className="vector-bg"></div>
              <div className="review-content">
                <div className="avatar-container">
                  <div className="avatar-bg"></div>
                  <img src={review.avatar} alt={review.name} className="avatar" />
                  <div className="avatar-overlay"></div>
                </div>
                <div className="review-text">
                  <h3>{review.name}</h3>
                  <p className="position">{review.position}</p>
                  <p className="quote">{review.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// Компонент модального окна информации о гранте
function GrantPopup({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="grant-popup">
        <button className="popup-close" onClick={onClose}>
          <img src={CloseIcon} alt="Закрыть" />
        </button>
        
        <div className="grant-header">
          <h3>Информация о гранте</h3>
          <p>КОНКУРС «СТУДЕНЧЕСКИЙ СТАРТАП» (ОЧЕРЕДЬ V) Это конкурс 2024 года. Участвовало около 6 000 различных проектов. Из федерального бюджета победителю выделяется 1 000 000 рублей на реализацию своей бизнес идеи. Я участвовала в направлении «Креативные индустрии»</p>
        </div>
        
        <div className="grant-image">
          <div className="grant-placeholder"></div>
          {/* Замените на реальное изображение диплома */}
          <img src={DiplomaImage} alt="Диплом" className="diploma-img" />
        </div>
      </div>
    </div>
  );
}

// Компонент секции Полины
function PolinaSection({ id }) {
 const [showGrantPopup, setShowGrantPopup] = useState(false);
  return (
    <div id={id} style={{ position: 'relative', width: '1280px', marginTop: '170px' }}>
      <GrantPopup isOpen={showGrantPopup} onClose={() => setShowGrantPopup(false)} />
      {/* Заголовок с абсолютным позиционированием */}
      <div style={{
        position: 'absolute',
        top: '0',
        left: 'calc(50% - 673px/2 - 303.5px)',
        width: '673px',
        height: '96px',
        zIndex: 10
      }}>
        <h2 style={{
          fontFamily: 'Montserrat, sans-serif',
          fontStyle: 'normal',
          fontWeight: 700,
          fontSize: '48px',
          lineHeight: '48px',
          letterSpacing: '0.0037em',
          color: '#14151A',
          marginLeft: "50px"
        }}>
          Динамику создают <span style={{ color: '#5196FF' }}>профессионалы</span>
        </h2>
      </div>

      {/* Остальной контент */}
      <div className="polina-section">
        <div className="polina-photo">
          <div className="photo-gray-rect">
            <img src={Polina} alt='Polina' className='polina-foto'/>
          </div>
        </div>
        <div className="polina-text">
          <div className="polina-title">
            <h2>Полина Шарафутдинова</h2>
            <p>Основатель и методолог проекта</p>
          </div>
          <div className="polina-quote-frame">
            <p>Научный эксперт в области социологии, имеет опыт работы научным исследователем. Работает в оценке персонала крупного холдинга со штатом более 100 тысяч работников. Лично курирует, модифицирует и адаптирует методологическую базу проекта.</p>
            <div className="ellipse121"></div>
            <div className="ellipse122"></div>
          </div>
          <img src={Ques} alt='Ques' className='ques'/>
          <div className="polina-content">
            <p>В 17 лет, после 7 лет академического художественного образования, я не знала, чем хочу заниматься в жизни. И внезапно я увлеклась социологией, в которую влюбилась раз и навсегда. <br /> <br /> Более 4 лет я вела научную деятельность в области социологии и социальной психологии. Получила красный диплом по специальности «Социология деловых коммуникаций». Имею научные публикации, выступаю на научных конференциях, участвую и побеждаю в международных конкурсах, провела десятки научных исследований.</p>
            <p>Сейчас я занимаюсь оценкой персонала, которая идеально совместила в себе страсть к исследованиям и любовь к людям. Профессионально оцениваю персонал от генеральных директоров до рабочих. Курирую проекты единовременной оценки более 55 тысяч сотрудников. <br /> <br /> Безграничная любовь к своей работе вдохновила меня на «Динамика». Я хотела создать приложение, которое позволило бы сотрудникам работать в комфортной обстановке, а руководителям лучше знать своих сотрудников. Вера в свое дело позволила мне выиграть <span className="grant-link" onClick={() => setShowGrantPopup(true)}>грант на 1 000 000 рублей</span> для воплощения моих идей в жизнь.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

// Компонент секции команды
function TeamSection() {
  return (
    <div className="team-section">
      <div className="team-container">
        {/* Ярослав */}
        <div className="team-member">
          <div className="member-photo">
            <div className="photo-gray-rect"></div>
            <img src={YarPhoto} alt="Ярослав Тихоньких" className="member-img" />
            <div className="photo-blue-overlay"></div>
          </div>
          <div className="member-info">
            <h3>Ярослав Тихоньких</h3>
            <p className="position">Frontend-разработчик</p>
            <p className="description">Специалист IT-сферы, занимается созданием ПО для разработки веб и десктоп-приложений, включая уникальные решения для управления коллективами. Опыт более 7 лет в создании автоматических измерительных систем и интеграции образовательных и VR технологий, безграничная техническая экспертиза. Выпускник СПбГМТУ и ЛЭТИ, обширные знания в области инженерной защиты окружающей среды и управления современными предприятиями.</p>
          </div>
        </div>

        {/* Юлия */}
        <div className="team-member">
          <div className="member-photo">
            <div className="photo-gray-rect"></div>
            <img src={JuliaPhoto} alt="Юлия Людвиновская" className="member-img" />
            <div className="photo-blue-overlay"></div>
          </div>
          <div className="member-info">
            <h3>Юлия Людвиновская</h3>
            <p className="position">UX/UI дизайнер</p>
            <p className="description">Занимается проектированием и дизайном сложных десктопных приложений, а также сайтов и лендингов. Разрабатывает интуитивно понятные интерфейсы, которые привлекают своей эстетикой и удобством. Работает над улучшением пользовательского опыта, что повышает конверсию продукта. Реализовано более 90 проектов, среди клиентов — строительные компании, страховые компании, рекламные агентства. Опыт работы в дизайне — более 14 лет. Имеет два высших образования: СПбГУ Политех и РГПУ им. Герцена.</p>
          </div>
        </div>

        {/* Денис */}
        <div className="team-member">
          <div className="member-photo">
            <div className="photo-gray-rect"></div>
            <img src={DenisPhoto} alt="Денис Резников" className="member-img" />
            <div className="photo-blue-overlay"></div>
          </div>
          <div className="member-info">
            <h3>Денис Резников</h3>
            <p className="position">Backend-разработчик</p>
            <p className="description">Имеет опыт написания платформ, сайтов, приложений. Выпускник СПбГМТУ.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

// Компонент секции контактов
function ContactSection({ id }) {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    question: '',
    agreement: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Здесь будет логика отправки формы
    console.log('Form submitted:', formData);
  };

  return (
    <div id={id} className="contact-section">
      <div className="contact-title">
        <h2>Мы всегда рады ответить на ваши вопросы</h2>
        <p>Свяжитесь с нами удобным вам способом!</p>
      </div>
      
      <div className="contact-content">
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="inputs-agreement">
            <div className="form-inputs">
              <div className="input-group">
                <label>Ваше имя</label>
                <div className="input-frame">
                  <input
                    type="text"
                    name="name"
                    placeholder="Например, Евгений"
                    value={formData.name}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              
              <div className="input-group">
                <label>Название компании</label>
                <div className="input-frame">
                  <input
                    type="text"
                    name="company"
                    placeholder="Например, Динамика"
                    value={formData.company}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              
              <div className="input-group">
                <label>Ваш E-mail</label>
                <div className="input-frame">
                  <input
                    type="email"
                    name="email"
                    placeholder="evgeniy@gmail.com"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              
              <div className="input-group">
                <label>Ваш вопрос</label>
                <div className="input-frame textarea-frame">
                  <textarea
                    name="question"
                    placeholder="Подскажите, пожалуйста..."
                    value={formData.question}
                    onChange={handleInputChange}
                    rows="4"
                  />
                </div>
              </div>
            </div>
            
            <div className="agreement">
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  name="agreement"
                  checked={formData.agreement}
                  onChange={handleInputChange}
                  className="custom-checkbox"
                />
                <span className="checkmark"></span>
              </div>
              <span className="agreement-text">
                Я даю согласие на обработку моих персональных данных, указанных в этой веб-форме, на условиях, изложенных в Политике в отношении обработки персональных данных в Интернете, с которой я ознакомился.
              </span>
            </div>
          </div>
          
          <button type="submit" className="submit-button">
            Оставить заявку
          </button>
        </form>
        
        <div className="contact-info">
          <div className="phone-number">8-911-163-69-01</div>
          <div className="email">OOODynamika@yandex.ru</div>
          <img src={iconTeleg} alt='Телеграм'/>
          <div className="support-section">
            <div className="support-text">
              <p>Проект выполнен при поддержке Фонда содействия инновациям в рамках программы «Студенческий стартап» федерального проекта «Платформа университетского технологического предпринимательства»</p>
            </div>
            
            <div className="emblems-container">
              <div className="emblem emblem1">
                <img src={Emblem1} alt="Эмблема 1" className="emblem-img" />
              </div>
              <div className="emblem emblem2">
                <img src={Emblem2} alt="Эмблема 2" className="emblem-img" />
              </div>
            </div>
          </div>
        </div>
        
        <div className="phone-background">
          <img src={PhoneIcon} alt="Phone" />
        </div>
      </div>
    </div>
  );
}

// Основной компонент App
function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <div className="AppPC">
      <ContactPopup isOpen={isPopupOpen} onClose={closePopup} />
      
      <div className='menuPC'>
        <img 
          src={Logo} 
          alt="Динамика" 
          onClick={scrollToTop}
          style={{ cursor: 'pointer' }}
        />
        <div className='menuBoard'>
          <button className='menuButton menuFont' onClick={() => scrollToElement('screen3')}>Для кого</button>
          <button className='menuButton menuFont' onClick={() => scrollToElement('screen4')}>О сервисе</button>
          <button className='menuButton menuFont' onClick={() => scrollToElement('screen6')}>Как работает</button>
          <button className='menuButton menuFont' onClick={() => scrollToElement('polina')}>Команда</button>
          <button className='menuButton menuFont' onClick={() => scrollToElement('contacts')}>Контакты</button>
        </div>
        <button className="callback-button" onClick={openPopup}>
          <p>Обратный звонок</p>
        </button>
      </div>
      
      {/* Контейнер для первого экрана */}
      <div className="first-screen">
        <img src={Screen1} alt="Первый экран" className="screen-bg"/>
        
        {/* Кнопка размещена внутри контейнера первого экрана */}
        <button className="request-button" onClick={openPopup}>
          <span className="request-text">Оставить заявку</span>
        </button>
      </div>
      
      {/* Контейнер для второго экрана с пазлом */}
      <div className="screen2-container">
        <img src={Puzzle} alt="Пазл" className="puzzle-bg" />
        <img src={Screen2} alt="Второй экран" className="screen2" />
      </div>
      
      <img src={Screen3} alt="Третий экран" id="screen3" style={{ marginTop: '170px' }} />
      
      {/* Контейнер для четвертого экрана с кнопкой */}
      <div className="screen4-container" id="screen4">
        <img src={Screen4} alt="Четвертый экран" className="screen4-bg" />
        <button className="ask-button" onClick={openPopup}>
          <span className="ask-text">Задать вопрос</span>
        </button>
      </div>
      
      <img src={Screen5} alt="Пятый экран" className='screen5' />
      <img src={Screen6} alt="Шестой экран" id="screen6" style={{ marginTop: '170px', marginLeft: '-50px' }} />
      <img src={Uni} alt="Университет" style={{ marginTop: '170px' }} />
      
      {/* Добавляем слайдер с отзывами */}
      <ReviewsSlider />
      <PolinaSection id="polina" />
      <TeamSection />
      <ContactSection id="contacts" />
    </div>
  );
}

export default App;